import React from 'react';

import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

type Card = {
  icon: React.ReactElement;
  title: string;
  body: string;
};

const CARDS: readonly Card[] = [
  {
    icon: <VisibilityOutlinedIcon fontSize="large" />,
    title: 'Our Vision',
    body: 'To provide a total exhibition of industrial technology envisaged in one innovative and confident engineering company driven by a true passion to provide intelligent factory answers.',
  },
  {
    icon: <FlagOutlinedIcon fontSize="large" />,
    title: 'Our Mission',
    body: 'To promote value addition in the supply chain while creating employment through entrepreneurship, market-focused strategies, and a commitment to excellence in serving customers.',
  },
  {
    icon: <VerifiedOutlinedIcon fontSize="large" />,
    title: 'Our Core Values',
    body: 'Excellent and quick service delivery, Driven by technology and innovation, Integrity and excellent professionalism, Belief in long-term client partnership and trust.',
  },
];

export default function HomeVisionMissionValues(): React.ReactElement {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 pb-16 pt-2 sm:px-6 lg:px-12 lg:pb-20 lg:pt-4">
        <div className="grid gap-6 lg:grid-cols-3">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="rounded-2xl bg-sky-600 p-8 text-left"
            >
              <div className="flex items-center gap-4">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white/20 text-white/80">
                  {card.icon}
                </div>
                <h3 className="text-3xl font-semibold text-white/80">{card.title}</h3>
              </div>
              <p className="mt-5 text-base leading-relaxed text-white/80">
                {card.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
